__turbopack_context__.v({
  "bottomBtn": "loginComponent-module-scss-module__iFr2KG__bottomBtn",
  "bottomBtnsWrapper": "loginComponent-module-scss-module__iFr2KG__bottomBtnsWrapper",
  "loginComponent": "loginComponent-module-scss-module__iFr2KG__loginComponent",
  "loginComponentTitle": "loginComponent-module-scss-module__iFr2KG__loginComponentTitle",
  "loginForm": "loginComponent-module-scss-module__iFr2KG__loginForm",
  "loginFormBottom": "loginComponent-module-scss-module__iFr2KG__loginFormBottom",
  "loginFormBottomText": "loginComponent-module-scss-module__iFr2KG__loginFormBottomText",
  "loginFormPasswordWrapper": "loginComponent-module-scss-module__iFr2KG__loginFormPasswordWrapper",
  "loginFormSubFormText": "loginComponent-module-scss-module__iFr2KG__loginFormSubFormText",
  "loginFormSubFormWrapper": "loginComponent-module-scss-module__iFr2KG__loginFormSubFormWrapper",
  "loginFormTitle": "loginComponent-module-scss-module__iFr2KG__loginFormTitle",
  "signUpLinck": "loginComponent-module-scss-module__iFr2KG__signUpLinck",
});
